import { sub } from 'date-fns'
import { useEffect, useState } from 'react'

import { useGetPerformanceReadingsQuery } from '../../app/apiSliceCoreLogicApi'
import { AdminPage, AdminPageHeader } from '../../common/components'
import { Select } from '../../common/designs'
import UsageHistogram from './UsageHistogram'
import { PerformanceReadingTypeEnum } from './types'

const PerformanceMonitoring = () => {
  const [daysSelected, setDaysSelected] = useState<number>(7)
  const [timePeriod, setTimePeriod] = useState<{
    start_timestamp: string
    end_timestamp: string
  } | null>(null)

  const { data: cpuData, isFetching: isLoadingCpuData } = useGetPerformanceReadingsQuery(
    {
      start_timestamp: timePeriod?.start_timestamp ?? '',
      end_timestamp: timePeriod?.end_timestamp ?? '',
      reading_type: PerformanceReadingTypeEnum.CPU,
    },
    { skip: !timePeriod },
  )
  const { data: memoryData, isFetching: isLoadingMemoryData } = useGetPerformanceReadingsQuery(
    {
      start_timestamp: timePeriod?.start_timestamp ?? '',
      end_timestamp: timePeriod?.end_timestamp ?? '',
      reading_type: PerformanceReadingTypeEnum.MEMORY,
    },
    { skip: !timePeriod },
  )

  useEffect(() => {
    const today = new Date() // Defaults time to host computer!

    setTimePeriod({
      start_timestamp: sub(today, { days: daysSelected - 1 }).toISOString(),
      end_timestamp: today.toISOString(),
    })
  }, [daysSelected])

  return (
    <AdminPage width='full'>
      <AdminPageHeader
        title='Performance Readings'
        description='Analyze CPU and memory usage distributions for the selected period.'
        actions={
          <Select
            value={daysSelected}
            options={[
              { label: 'Last 3 Days', value: 3 },
              { label: 'Last 7 Days', value: 7 },
              { label: 'Last 14 Days', value: 14 },
              { label: 'Last 30 Days', value: 30 },
              { label: 'Last 60 Days', value: 60 },
              { label: 'Last 90 Days', value: 90 },
            ]}
            onChange={(days: number) => setDaysSelected(days)}
          />
        }
      />

      <div className='mt-8 grid grid-cols-1 gap-4 3xl:grid-cols-2'>
        <div className='space-y-4'>
          <UsageHistogram
            unit={PerformanceReadingTypeEnum.CPU}
            data={cpuData}
            isLoading={isLoadingCpuData}
          />
        </div>

        <div className='space-y-4'>
          <UsageHistogram
            unit={PerformanceReadingTypeEnum.MEMORY}
            data={memoryData}
            isLoading={isLoadingMemoryData}
          />
        </div>
      </div>
    </AdminPage>
  )
}

export default PerformanceMonitoring

